import { connect } from "react-redux";
import { TextArea as Component } from "./component";
import { updateText } from './store/actions';

/**
 * mapStateToProps - Function to map the state from the Redux store to the props of the component.
 *
 * @param {Object} state - The current state of the Redux store.
 * @param {Object} ownProps - The properties passed to the component.
 *
 * @returns {Object} - An object with the mapped state to be used as props in the component.
 */
const mapStateToProps = (state, ownProps) => {
  return {
      // If there's an entry in the textArea state corresponding to the component's ID, use it.
      // Otherwise, default to an empty string.
      text: state.textArea[ownProps.id] ? state.textArea[ownProps.id] : ""
  };
};

/**
 * mapDispatchToProps - Function to map the dispatch actions to the props of the component.
 *
 * @param {Function} dispatch - The dispatch function of the Redux store.
 *
 * @returns {Object} - An object with the mapped dispatch actions to be used as props in the component.
 */
const mapDispatchToProps = (dispatch) => {
  return {
      // The updateText action is dispatched with the text provided.
      updateText: (text) => dispatch(updateText(text))
  };
};

// Using the Redux `connect` function to connect our component to the Redux store.
// This creates a new component that is connected to the Redux state and actions, which can be used like any React component.
export const TextArea = connect(mapStateToProps, mapDispatchToProps)(Component);
